const option = [
    { id: 'normal', name: 'ทั่วไป' },
    { id: 'sublet', name: 'สินค้าโป๊ว' },
    { id: 'consign', name: 'ฝากขาย' }
]

export default {
    option: option
};